import { render, staticRenderFns } from "./sucess.vue?vue&type=template&id=6ac9bf01&scoped=true&"
import script from "./sucess.vue?vue&type=script&lang=js&"
export * from "./sucess.vue?vue&type=script&lang=js&"
import style0 from "./sucess.vue?vue&type=style&index=0&id=6ac9bf01&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac9bf01",
  null
  
)

export default component.exports